import React from "react";
import "./Hero.css";
import { useTranslation } from "react-i18next";

const Hero = () => {
  const { t } = useTranslation();
  return (
    <header className="hero">
      <div className="hero-inner container">
        <div className="hero-copy">
          <h1>{t("hero.title")}</h1>
          <p>{t("hero.subtitle")}</p>
          <div className="hero-ctas">
            <a className="btn primary" href="/services">
              {t("hero.ctaPrimary")}
            </a>
            <a className="btn secondary" href="/contact">
              {t("hero.ctaSecondary")}
            </a>
          </div>
        </div>
        <div className="hero-visual">
          <img src="/pictures/star.png" alt="STARGATE Logo" />
        </div>
      </div>
    </header>
  );
};

export default Hero;
